
function JobReportIcon() {
	return (
		<svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<g
				fill="#FFFFFF"
				stroke="#FFFFFF"
				strokeLinecap="square"
				strokeLinejoin="miter"
				strokeMiterlimit="10"
				strokeWidth="2"
			>
				<polyline fill="none" points="17,2 22,2 22,23 2,23 2,2 7,2 " stroke="#FFFFFF" />
				<polyline fill="none" points=" 9,15 11,17 15,13 " />
				<path d="M7,1v6h3 c0-1.105,0.895-2,2-2s2,0.895,2,2h3V1H7z" fill="none" stroke="#FFFFFF" />
			</g>
		</svg>
	);
}

export default JobReportIcon;
